import { createApp } from '@backstage/frontend-defaults';
import { techDocsReportIssueAddonModule } from '@backstage/plugin-techdocs-module-addons-contrib/alpha';

const app = createApp({
  features: [techDocsReportIssueAddonModule],
});

export default app;
